export default "__VITE_ASSET__BnEl6nUO__"